/**
 * @file 公共mitations，用于更改全局配置项
 * @author jiangjun
 */

export default {
    'SET_USER_INFO'(state, userInfo) {
        state.userInfo = userInfo
    },
    'SET_ENUM_LIST'(state, list) {
        state.enumList = list
    },
    'SET_CACHED_VIEWS'(state, value) {
        state.cachedViews = value
    },
    'SHOW_ADD_ORGANIZATION'(state, event) {
        state.addOrganizationState = true
        state.command = event.command
        state.organization = event.organization
    },
    'HIDE_ADD_ORGANIZATION'(state) {
        state.addOrganizationState = false
        state.command = null
        state.organization = null
    },
    'SHOW_ADD_MANAGE_AREA'(state) {
        state.addManageAreaState = true
    },
    'HIDE_ADD_MANAGE_AREA'(state) {
        state.addManageAreaState = false
    },
}
